/** Dashboard paths for the v2 Organized Tours module (parallel to legacy until cutover). */
export const OT_MODULE_BASE = "/p/dashboard/organized-tours";

export const ORGANIZED_TOURS_SEARCH_PATH = `${OT_MODULE_BASE}/search`;
export const ORGANIZED_TOURS_RESULTS_PATH = `${OT_MODULE_BASE}/results`;

export function organizedTourProfilePath(dealId) {
  const id = encodeURIComponent(String(dealId ?? "").trim());
  if (!id) return ORGANIZED_TOURS_RESULTS_PATH;
  return `${OT_MODULE_BASE}/profile/${id}`;
}

/** נוסעים / נעילת פרטי הזמנה לפני תשלום */
export function organizedTourBookingPath(orderId) {
  const id = encodeURIComponent(String(orderId ?? "").trim());
  if (!id) return ORGANIZED_TOURS_RESULTS_PATH;
  return `${OT_MODULE_BASE}/booking/${id}`;
}

export function organizedTourPaymentPath(orderId) {
  const id = encodeURIComponent(String(orderId ?? "").trim());
  if (!id) return ORGANIZED_TOURS_RESULTS_PATH;
  return `${OT_MODULE_BASE}/payment/${id}`;
}
